import { Link, useLocation } from 'react-router-dom'
import './AdminLayout.css'

interface AdminLayoutProps {
  children: React.ReactNode
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const location = useLocation()

  const menuItems = [
    { path: '/admin', label: '대시보드', icon: '📊' },
    { path: '/admin/notices', label: '공지사항 관리', icon: '📢' },
    { path: '/admin/semesters', label: '학기 관리', icon: '📅' },
    { path: '/admin/courses/create', label: '강의 등록', icon: '➕' },
    { path: '/admin/courses/list', label: '강의 목록', icon: '📚' },
    { path: '/admin/enrollments', label: '수강신청 관리', icon: '✍️' },
    { path: '/admin/grades', label: '성적 관리', icon: '📝' },
    { path: '/admin/completions', label: '이수 관리', icon: '✅' },
    { path: '/admin/users', label: '회원 관리', icon: '👥' },
    { path: '/certificate', label: '이수증명서', icon: '📄' },
    { path: '/admin/legacy-completions', label: '이전 이수 내역', icon: '📜' },
    { path: '/admin/statistics', label: '통계', icon: '📈' },
  ]

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <h2 className="admin-sidebar-title">관리자 메뉴</h2>
        <nav className="admin-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="admin-nav-icon">{item.icon}</span>
              <span className="admin-nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>
      </aside>
      <div className="admin-content">
        {children}
      </div>
    </div>
  )
}

